import React, { useEffect, useState } from 'react';
import {
  Card,
  Form,
  Input,
  Button,
  Upload,
  Radio,
  message,
  Modal,
  Collapse,
  Select, Spin
} from "antd";
import {
    LoadingOutlined,
    PlusOutlined
} from '@ant-design/icons';
import './index.css';
import Dialog from '../dialog/index';
import DialogCreate from '../addKCSDialog/index';
import {
    uploadImgRequest,
    createKcsFileList,
} from './api';
import styles from "../CreactApp/create.module.css";
import { API_URL } from '../../../../util/constants';
import Cookies from 'js-cookie';

const { Panel } = Collapse;
const { Meta } = Card;
const { Option } = Select;
// const API_URL = 'http://ygbhpy.gamepku.com';
const { TextArea } = Input;
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const TextPage = (props) => {
    // const onFinish = (values) => {
    //     console.log('Form values: ', values);
    // };
    const [messageApi, contextHolder] = message.useMessage();
    const [modal, contextHolder2] = Modal.useModal();
    const [form] = Form.useForm();
    const [templateType, setTemplateType] = useState('custom');
    const [dialogFlag, setDialogFlag] = useState(false);
    const [dialogFlag2, setDialogFlag2] = useState(false);
    const [agentName, setAgentName] = useState('');
    const [agentEasyInfo, setAgentEasyInfo] = useState('');
    const [beginText, setBeginText] = useState('');
    const [beginQuestion, setBeginQuestion] = useState('');
    const [questionList, setQuestionList] = useState([]);
    const [tishiText, setTishiText] = useState('');
    const [tishiText2, setTishiText2] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
    const [dataset_id, setDataset_id] = useState(props.id);
  const [iconImg, setIconImg] = useState('');
  const [fileList, setFileList] = useState([]);
  const [selectedValue, setSelectedValue] = useState('\n'); // 默认值与 Select 的 defaultValue 一致
  const [isLoading, setIsLoading] = useState(false);
    //本地存储过期控制，前端水印实现方案
    //声明一个初始化变量 将这个变量 初始化生命一
    useEffect(() => {}, []);
    const onFinish = (values) => {
        console.log('Received values:', values);
        message.success('智能体保存成功');
    };

  // 允许上传的文件类型
  const ACCEPT_FILE_TYPES = [
    '.pdf', '.txt', '.doc', '.docx', '.md',
  ];

  const onCancelTextPage = () => {
    props.onCancelTextPage();
  };

// 校验文件类型
  const beforeUpload = (file) => {
    const fileType = `.${file.name.split('.').pop().toLowerCase()}`;
    const isTypeValid = ACCEPT_FILE_TYPES.includes(fileType) ||
      ACCEPT_FILE_TYPES.includes(file.type);

    if (!isTypeValid) {
      message.error(`不支持的文件类型: ${file.name}`);
      return Upload.LIST_IGNORE; // 忽略此文件
    }

    // 可以添加更多校验逻辑，如文件大小限制等
    return true;
  };
    const onClickCancel = () => {
        setDialogFlag(false);
    };
    const onClickCancel2 = () => {
        setDialogFlag2(false);
    };


  // 文件转 Base64 的工具函数
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  // 去除 Base64 前缀的工具函数
  const removeBase64Prefix = (base64String) => {
    return base64String.split(',')[1] || base64String;
  };

    const handleChange  = async ({ file, fileList }) => {
        console.log(fileList, 'info');
      // 只处理新增的文件（通过 uid 判断）
      const newFile = fileList.find(f => f.uid === file.uid);

      if (newFile) {
        try {
          // 执行 Base64 转换
          const base64 = await convertToBase64(newFile.originFileObj);
          const base64WithoutPrefix = removeBase64Prefix(base64);

          // 更新当前文件对象，添加 base64 字段
          const updatedFile = {
            ...newFile,
            base64: base64WithoutPrefix, // 添加 Base64 数据
            status: 'done', // 标记为已完成
          };

          // 更新 fileList，替换原有文件对象
          const updatedFileList = fileList.map(f =>
            f.uid === newFile.uid ? updatedFile : f
          );

          setFileList(updatedFileList); // 更新状态
          console.log('Base64 转换成功并已添加到 fileList');

        } catch (error) {
          console.error('转换失败:', error);
        }
      }
    };
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type='button'
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    const customRequest = async ({ file, onSuccess, onError }) => {
        try {
            // 生成新文件名（可根据需求修改）
             const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
             const newFileName = `img_${Date.now()}_${Cookies.get('user_login')}.${fileExt}`;

            // 调用你的上传接口
            await uploadImgRequest(file, newFileName, (data) => {
                if (data.ret == 1) {
                    // const fileUrl = `${API_URL}/icons/${newFileName}`;
                    // onSuccess({ ...file, url: fileUrl }, file);
                    // onUploadSuccess?.(fileUrl); // 可选：通知父组件上传成功
                    file.url = API_URL + '/icons/' + newFileName;
                    // file.name = newFileName
                    onSuccess(file);
                    setIconImg(data.imgInfo.id);
                } else {
                    onError(data);
                    message.error('上传失败: ' + (data.message || '未知错误'));
                }
            });
        } catch (error) {
            onError(error);
            message.error('上传失败: ' + error.message);
        }
    };

    const changeAgentName = (e) => {
        setAgentName(e.target.value);
    };
    const changeAgentEasyInfo = (e) => {
        setAgentEasyInfo(e.target.value);
    };
    const changeBeginText = (e) => {
        setBeginText(e.target.value);
    };
    const changeBeginQuestion = (e) => {
        setBeginQuestion(e.target.value);
        setQuestionList(e.target.value.split(';'));
    };
    const onSetValueFn = (value, flag) => {
        setTishiText(value);
        setDialogFlag(flag);
    };
    const onSetValueFn2 = (value, flag) => {
        setTishiText2(value);
        setDialogFlag2(flag);
    };
    const changeTishiText = (e) => {
        setTishiText(e.target.value);
    };
    const addKCSKu = () => {
        setDialogFlag2(true);
    };
    const [radioType, setRadioType] = useState(false);
    const changeType = (e) => {
        console.log(e.target.value, 'set');
      setRadioType(e.target.value);
        // if (e.target.value == 'a') {
        //     setRadioType(false);
        // } else {
        //     setRadioType(true);
        // }
    };
    const clickSubmit = () => {};
    return (
      <Modal
        maskClosable={false}
        title='新增知识库'
        okText='确认'
        cancelText='取消'
        onCancel={onCancelTextPage}
        onOk={() => {

          form.validateFields([
            'segmentationIdentifier', // 分段标识符（自定义模式下必填）
            'maxSegmentLength', // 分段最大长度（自定义模式下必填）
          ])
            .then((values) => {

              if (fileList.length===0) {
                message.error('请上传文件');
              }else{

                setIsLoading(true);
                const newDocumentBases = fileList
                  .filter(f => f.base64)
                  .map(f => {
                    // 从文件名提取扩展名（包含点号）
                    const extWithDot = f.name.slice((f.name.lastIndexOf('.') - 1 >>> 0) + 2);
                    // 转换为小写并去除点号作为文件类型
                    const fileType = extWithDot.toLowerCase() || 'unknown';

                    return {
                      name: f.name,
                      source_info: {
                        file_base64: f.base64,
                        file_type: fileType,
                        document_source: 0,
                      },
                    };
                  });
                console.log(newDocumentBases)

                var param = {
                  dataset_id: dataset_id,
                  format_type: 0,
                  document_bases: newDocumentBases,
                  chunk_strategy: radioType===0?{  //0: 自动分段与清洗。采用扣子预置规则进行数据分段与处理。1: 自定义。
                    "chunk_type": radioType,
                  }:{
                    "chunk_type": radioType,
                    "separator":selectedValue==='custom'?form.getFieldValue('segmentationIdentifier'):selectedValue, //分段标识符
                    "max_tokens":Number(form.getFieldValue('maxSegmentLength')), //最大分段长度integer
                  }
                }
                console.log(param)

                createKcsFileList( param,
                  (res) => {
                    if (res.ret == 1) {
                      console.log(res)
                      message.success('知识库文件创建成功');
                      setIsLoading(false);
                      onCancelTextPage()
                    }else{
                      message.error('操作失败');
                      setIsLoading(false);
                    }
                })
              }
            }).catch((info) => {
            console.log('Validate Failed:', info);
            setIsLoading(false);
          });

          }
        }
        visible={true}>
        <div >
            {contextHolder}
            {contextHolder2}
            <Card
                title=''
                bordered={false}
                className='create_card'
            >
                <Form
                  form={form}
                    name='upload_form'
                    className='upload_form'
                    // onFinish={onFinish}
                    layout='vertical'
                    initialValues={{
                      name: '',
                      description: '',
                      prompt: '0',
                    }}
                >

                  <div
                    className={styles.title}
                    style={{marginTop:10,marginBottom:10}}
                  >
                    1.上传文件<div style={{color:'red',marginLeft:2}}></div>
                  </div>

                        <Upload
                            //fileList={fileList}
                            accept={ACCEPT_FILE_TYPES.join(',')}
                            name='avatar'
                            listType="text"
                            className='avatar-uploader'
                            onChange={handleChange}
                            // customRequest={customRequest}
                            showUploadList={true}
                          //beforeUpload={beforeUpload}
                            beforeUpload={() => false}
                          // showUploadList={false} // 不显示上传列表
                            showUploadList={{ showRemoveIcon: true }} // 显示删除图标（默认值为 true）


                        >
                          <Button className="flex items-center bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-md px-4 py-2 transition-colors">
                            <i className="fa fa-file-text-o mr-2 text-blue-600" />
                            <span>上传文件</span>
                          </Button>

                        </Upload>
                        <div style={{ marginTop: 8 }}>
                            支持 PDF, TXT, DOC, DOCX, MD 文件, 最多可上传 300 个文件，每个文件不超过
                            10MB, PDF 最多 500 页
                        </div>


                  <div
                    className={styles.title}
                    style={{marginTop:10,marginBottom:10}}
                  >
                    2.分段策略<div style={{color:'red',marginLeft:2}}></div>
                  </div>


                    <Radio.Group defaultValue={0} onChange={changeType}>
                        <Radio value={0}>自动分段与清洗（自动分段与预处理规则）</Radio>
                        <Radio value={1}> 自定义（自定义分段规则、分段长度及预处理规则）</Radio>
                    </Radio.Group>

                    {radioType===1 ? (
                        <>
                          <div
                            className={styles.title}
                            style={{marginTop:10,marginBottom:10,fontSize:14}}
                          >
                            分段标识符<div style={{color:'red',marginLeft:2}}>※</div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Select
                              style={{ width: '45%', marginRight: 20 }}
                              defaultValue='\n'
                              onChange={(value) => setSelectedValue(value)} // 选中值变化时更新状态
                            >
                              <Option value='\n'>换行</Option>
                              <Option value='。'>中文句号</Option>
                              <Option value='custom'>自定义</Option>
                            </Select>
                          </div>

                          {selectedValue === 'custom' && (
                            <Form.Item
                              style={{marginTop: 10 }}
                              label=""
                              name="segmentationIdentifier"
                              rules={[{ required: true, message: '请输入分段标识!' }]}
                            >
                              <Input style={{ width: '45%' }} addonAfter="###" placeholder="请输入分段标识"/>
                            </Form.Item>
                          )}


                          <div
                            className={styles.title}
                            style={{marginTop:10,marginBottom:10,fontSize:14}}
                          >
                            分段最大长度<div style={{color:'red',marginLeft:2}}>※</div>
                          </div>
                            <Form.Item
                                label=''
                                name='maxSegmentLength'
                                rules={[
                                  { required: true, message: "请输入分段最大长度!" },
                                  // 自定义验证规则
                                  () => ({
                                    validator(_, value) {
                                      if (!value) return Promise.reject(); // 由 required 规则处理
                                      const num = Number(value);
                                      if (isNaN(num)) {
                                        return Promise.reject('请输入有效数字');
                                      }
                                      if (num < 100 || num > 2000) {
                                        return Promise.reject('请输入 100~2000 之间的数字');
                                      }
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                            >
                                <Input placeholder="请输入 100~2000 之间的数字"
                                       // addonAfter='字符'
                                       style={{ width: '100%' }}
                                  // 受控组件 + 输入过滤
                                       value={form.getFieldValue('maxSegmentLength')}
                                       onChange={(e) => {
                                         const rawValue = e.target.value;
                                         // 1. 过滤非数字字符
                                         const filteredValue = rawValue.replace(/[^\d]/g, '');
                                         // 2. 转换为数字并限制范围
                                         const num = Number(filteredValue);
                                         if (!isNaN(num) && num >= 100 && num <= 2000) {
                                           form.setFieldsValue({ maxSegmentLength: filteredValue });
                                         } else {
                                           form.setFieldsValue({ maxSegmentLength: filteredValue });
                                         }
                                       }}
                                />
                            </Form.Item>
                        </>
                    ) : null}


                  <div style={{ marginTop: 50 }}>点击确认后，数据进行处理需一定时间，处理完毕后可进行引用</div>

                    {/*<Form.Item>*/}
                        {/*<Button*/}
                            {/*type='primary'*/}
                            {/*htmlType='submit'*/}
                            {/*className='login-form-button'*/}
                            {/*onClick={clickSubmit}*/}
                        {/*>*/}
                            {/*确认并添加至该智能体*/}
                        {/*</Button>*/}
                        {/*<div>点击确认后，数据进行处理需一定时间，处理完毕后可进行引用</div>*/}
                    {/*</Form.Item>*/}
                </Form>
            </Card>
            <Dialog visible={dialogFlag} onCancel={onClickCancel} setValue={onSetValueFn} />
            <DialogCreate
                visible={dialogFlag2}
                onCancel={onClickCancel2}
                setValue={onSetValueFn2}
            />
        </div>

        {isLoading?
          <Spin
            size="large"
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1000
            }}/>:null}

          </Modal>
    );
};

export default TextPage;
